import router from "@/router"
export default {
    computed: {
        site() {
            return this.$store.getters.getSiteData;
        },
        block() {
            const block = this.site.blocks.find(function(block) {
                return block.id == router.currentRoute.params.id;
            });

            if(! block) {

                return false;
            }

            const hash = window.location.hash;
            const pathArray = hash.split('/');
            const type  = pathArray[3];

            if(block.type.toLowerCase() != type) {

               return false;
            }

            return block;
        }
    },
    created() {
        if(! this.block) {

            this.$router.push({ name: 'app-overview', params: { 'slug': router.currentRoute.params.slug }});
        }
    }
}